<template>
  <p class="text">
    <span>
      {{ paymentMonths }} payments of
      <b v-if="showIcon"> {{ priceText }}</b>
      <span v-else> {{ priceText }}</span>
      with <span v-if="!showIcon">{{ providerName }}</span>
    </span>
    <img
      v-if="showIcon"
      src="@/assets/images/payment-methods/clearpayV2.svg"
      width="78"
    />
  </p>
</template>

<script>
export default {
  name: "Clearpay",
  props: {
    price: {
      type: Object,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    providerName: {
      type: String,
      default: "Clearpay",
    },
    paymentMonths: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    monthlyPayment() {
      return this.price.amount / this.paymentMonths;
    },
    priceText() {
      const price = this.$filters.toCurrency(
        this.monthlyPayment,
        this.price.currencyCode
      );
      return price;
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  color: $color-grey-dark;
  margin: 8px 0 44px 0;
  @include utility-label(12px);
}
</style>
